export default function (value) {
  if (value > 60) {
    const minutes = Math.floor(value / 60);
    const seconds = value - minutes * 60;
    return `${minutes} m, ${seconds} s`;
  }
  return `${value} segundos`;
}
